import { render, staticRenderFns } from "./subscribeBlock.vue?vue&type=template&id=1518b206&"
import script from "./subscribeBlock.vue?vue&type=script&lang=js&"
export * from "./subscribeBlock.vue?vue&type=script&lang=js&"
import style0 from "./subscribeBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports